import React, { useState, useEffect } from 'react';
import search from "../../assets/images/search.png";
import pendingdot from "../../assets/images/pendingDot.png";
import activedot from "../../assets/images/activeDot.png";
import closeddot from "../../assets/images/closedDot.png";
import tododot from "../../assets/images/todoDot.png";
import { Input } from "reactstrap";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import axiosInstance from '../../helpers/axios';
import PaginationTable from '../status/PaginationTable';
import Modal from '@mui/material/Modal';
import Datetime from 'react-datetime';
import InstituteAutocomplete from '../../components/status/ProjectTable/InstituteSearch';
import calender from "../../assets/images/calender.png";
import edit from "../../assets/images/edit2.png"
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';  // ← also need this
import { useDispatch, useSelector } from 'react-redux';
import { userActions } from '../../actions/user.actions';
import { useNavigate } from 'react-router-dom';
import DescriptionIcon from '@mui/icons-material/Description';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import LoanActivity from '../LoanActivity/Loanactivity';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { BarChartIcon } from 'lucide-react';
  import RefreshIcon from '@mui/icons-material/Refresh';
import CheckBoxOutLinedIcon from '@mui/icons-material/CheckBox';
import * as moment from 'moment'
import { useCurrentUser } from '../../hooks/useCurrentUser';
import { appContextConstants } from '../../constants/appContext.constants';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

export const RefundTrackerStatus = {
  Requested: 1,
  InReview: 2,
  Rejected: 3,
  Approved: 4,
  RefundReceived: 5,
};

export const RefundTrackerStatusArray = [
  "", 
  "Requested",
  "In Review",
  "Rejected",
  "Approved",
 "Refund Received"

];


export const getRefundStatusLabel = (statusNumber) => {
  return RefundTrackerStatusArray[statusNumber] || "Requested";
};

export const getRefundStatusValue = (statusLabel) => {
  const index = RefundTrackerStatusArray.indexOf(statusLabel);
  return index > 0 ? index : 1; 
};

const FILTER_KEY = "refundsTrackerFilters";
const getSavedFilters = () => {
  try {
    return JSON.parse(sessionStorage.getItem(FILTER_KEY) || "null") || {};
  } catch {
    return {};
  }
};
const RefundsTracker = ()=>{
  const dispatch=useDispatch()
const navigate=useNavigate()
  
  const { loanid: ctxLoanid, legacyLoanId: ctxLegacyLoanId } = useSelector((state) => state.appContext);
  const savedFilters = getSavedFilters();
  const [totalFetchRows, setTotalFetchRows] = useState(null);
  const [currentPage, setcurrentPage] = useState(savedFilters.currentPage || 1);
  const [rowsPerPage, setrowsPerPage] = useState(savedFilters.rowsPerPage || 15);
  const [isLoading, setIsLoading] = useState(false); 
const [searchText, setSearchText] = useState("")
const [penaltyChecked, setPenaltyChecked] = useState(false);
const [id,setId] = useState(savedFilters.id || '')
  const [instituteName, setInstituteName] = useState(savedFilters.instituteName || '');
  const [statusFilter, setStatusFilter] = useState(savedFilters.statusFilter ?? ''); 
  const [createdFromDate, setCreatedFromDate] = useState(savedFilters.createdFromDate || null);
  const [createdToDate, setCreatedToDate] = useState(savedFilters.createdToDate || null);
  const [refundFromDate, setRefundFromDate] = useState(savedFilters.refundFromDate || null);
  const [refundToDate, setRefundToDate] = useState(savedFilters.refundToDate || null);
const [expandedRow, setExpandedRow] = useState(null); 
const [editData, setEditData] = useState({});  
const [refreshKey, setRefreshKey] = useState(0);
const [isEditLoading, setIsEditLoading] = useState(false);
const [isDialogOpen, setIsDialogOpen] = useState(false);
const [refundSummary, setRefundSummary] = useState({
  totalRefundAmount: 0,
  totalRefundCount: 0,
  approvedRefundCount:0
});
const [refundAggregate,setRefundAggregate]=useState({totalPos:0,totalCount:0,approvedAmount:0})

const [triggerDateSearch, setTriggerDateSearch] = useState(false);
const [instituteResetKey, setInstituteResetKey] = useState(0);
  useEffect(() => {
    sessionStorage.setItem(
      FILTER_KEY,
      JSON.stringify({
        id,
        instituteName,
        statusFilter,
        createdFromDate,
        createdToDate,
        refundFromDate,
        refundToDate,
        currentPage,
        rowsPerPage,
      })
    );
  }, [
    id,
    instituteName,
    statusFilter,
    createdFromDate,
    createdToDate,
    refundFromDate,
    refundToDate,
    currentPage,
    rowsPerPage,
  ]);
  useEffect(() => { window.addEventListener("beforeunload", () => sessionStorage.removeItem("refundsTrackerFilters")); }, []);
const handleUpdateRefund = (legacyLoanId) => {
  const payload = {
    legacyLoanId: legacyLoanId,
    amount: Number(editData.amountReceived) || 0,  
    status: editData.statusValue || 1,
    processedDate: editData.processedDate || null,
    prorataInterest: penaltyChecked 
      ? Number(editData.prorataInterest || 0) 
      : 0,                                           
    interestStartDate: penaltyChecked && editData.interestStartDate
      ? editData.interestStartDate                   
      : null,
  };

  setIsEditLoading(true);

  axiosInstance
    .post(`/refunds/update-refund-details`, payload, {
    })
    .then((res) => {
      alert("Refund details updated successfully");
      setRefreshKey((prev) => prev + 1);
      setExpandedRow(null);
      setEditData({});
      setPenaltyChecked(false);
    })
    .catch((err) => {
      alert(err?.response?.data?.message || "Update failed");
      console.error(err);
    })
    .finally(() => {
      setIsEditLoading(false);
    });
};


const buildQueryParams = () => {
  const params = {};

if (rowsPerPage) params.perPage = rowsPerPage;
  if (currentPage) params.pageNo = currentPage;
  if (id) params.instituteId = id; 

if (statusFilter && statusFilter !== '') {
  params.status = statusFilter;
}
  if (createdFromDate) params.createdFromDate = createdFromDate;
  if (createdToDate) params.createdToDate = createdToDate;
  if (refundFromDate) params.refundFromDate = refundFromDate;
  if (refundToDate) params.refundToDate = refundToDate;

  return params;
};

  const decode = useCurrentUser();
  const user = null;
    const [tableData, setTableData] = useState([])
  
useEffect(() => {
  setIsLoading(true);
 const params = buildQueryParams();
  axiosInstance.get('/refunds/get-refunds', {
    params,
    headers: {
    }
  })
  .then((res) => {
    const loans = res?.data?.data?.loans || [];
    setTableData(loans);
    setTotalFetchRows(res?.data?.data?.pagination?.totalRows || 0);
    setcurrentPage(res?.data?.data?.pagination?.currentPage || 1);
    setrowsPerPage(res?.data?.data?.pagination?.perPage || rowsPerPage);
    const approvedCount = loans.filter((loan) =>
      loan.status === 4 || loan.status === 'Approved'
    ).length
    setIsLoading(false);
  })
  .catch((error) => {
    alert(error?.response?.data?.message || "Error loading refunds");
    setIsLoading(false);
  });
}, [currentPage, rowsPerPage, triggerDateSearch, refreshKey]);


useEffect(()=>{
  const params=buildQueryParams()
 axiosInstance.get('/refunds/get-refund-aggregate',{
params,
  headers:{
  }
 })
 .then((res)=>{
  const data=res?.data?.data
  setRefundAggregate({
    totalPos:data[0].total_pos,
    totalCount:data[0].total_count,
    approvedAmount:data[0].approved_amount
  })
 })
},[triggerDateSearch, refreshKey])
const paginate = (pageNumber) => {
  setcurrentPage(pageNumber);
};
const formatAmount = (value = 0) => {
  if (value >= 10000000) return `${(value / 10000000).toFixed(2)} Cr`;
  if (value >= 100000) return `${(value / 100000).toFixed(2)} L`;
  if (value >= 1000) return `${(value / 1000).toFixed(2)} K`;
  return `${value}`;
};


  function formatNumberWithCommas(number) {
    return number?.toLocaleString('en-IN');
  }
const formatDateForInput = (dateStr) => {
  if (!dateStr) return '';
  

  const parts = dateStr.split('-');
  if (parts.length === 3) {
    const [day, month, year] = parts;
    return `${year}-${month}-${day}`;
  }
  
  return '';
};


  const handleLoanProfile=(loanId,legacyLoanId)=>{
   dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: { status: 'Disbursed' } });
   dispatch({ type: appContextConstants.SET_LOAN_CONTEXT, payload: { loanid: loanId, legacyLoanId: legacyLoanId } });
   const urlUsers = `/loan-repayment/profile?loanId=${loanId}`;
    const callDetailsUrl = `/call-history/details?loanId=${loanId}`;
    const emihistoryUrl=`/emis/for-loan?loanId=${loanId}`
    dispatch(userActions.fetchLoanDetails(urlUsers,user))
    dispatch(userActions.fetchCallDetails(callDetailsUrl,user))
    dispatch(userActions.getEmiHistory(emihistoryUrl,user))
    navigate('/LoanProfile')

  }

  const handleOpenDialog=(loanId,legacyLoanId)=>{
    dispatch({type:appContextConstants.SET_LOAN_CONTEXT,
             payload:{
                    loanid:loanId,
                legacyLoanId:legacyLoanId,
                  },
    });
    const getActivityUrl = `/loan-repayment/activity?legacyLoanId=${legacyLoanId}`
      setIsDialogOpen(true)
      dispatch(userActions.getLoanActivity(getActivityUrl,user))
  }
const handleCloseDialog = () => setIsDialogOpen(false);
 
    return(
        <div style={{width:"100%",backgroundColor:'white',minHeight:'100vh'}}>
                <div style={{display:'flex',justifyContent:'space-between'}}>
                  <h1 style={{fontFamily:'Inter-Medium',fontSize:'25px',fontWeight:'500',margin:0,marginTop:'10px',color:'#101828'}}>Refunds Tracker</h1>    
  
</div>

                <div style={{display:'flex',justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{display:'flex', justifyContent: 'space-between', alignItems: 'center', padding:'10px' }}>
  <div style={{display:'flex', gap:'20px'}}>
 {/* total refund amount */}
    <div style={{
      backgroundColor: '#F9FAFB',
      borderRadius:'12px',
      display:'flex',
      alignItems:'center',
      height:'70px',
      minWidth:'220px',
      justifyContent:'space-between',
      padding:'25px 20px',
      border:'1px solid #E4E7EC',
      cursor:'pointer'
    }}>
      <div style={{lineHeight:'1.4'}}>
        <span style={{
          color:'#D32028',
          fontSize:'24px',
          fontWeight:'600',
          fontFamily:'Inter-Medium',
          display:'block'
        }}>
          ₹{formatAmount(Math.floor(refundAggregate.totalPos))}
        </span>
        <span style={{
          fontSize:'14px',
          fontWeight:'500',
          fontFamily:'Inter-Medium',
          color:'#667085'
        }}
        
        >
          Principle OutStanding(POS)
        </span>
      </div>
      <div style={{
        backgroundColor:'#FEE2E2',
        borderRadius:'50%',
        width:'40px',
        height:'40px',
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
        marginLeft:'20px',
        
      }}>
        <CurrencyRupeeIcon sx={{ fontSize: '24px' }} />
      </div>
    </div>

  {/* refund-count */}
    <div style={{
      backgroundColor: '#F9FAFB',
      borderRadius:'12px',
      display:'flex',
      alignItems:'center',
      height:'70px',
      minWidth:'220px',
      justifyContent:'space-between',
      padding:'16px 20px',
      border:'1px solid #E4E7EC',
      cursor:'pointer'
    }}>
      <div style={{lineHeight:'1.4'}}>
        <span style={{
          color:'#D32028',
          fontSize:'24px',
          fontWeight:'600',
          fontFamily:'Inter-Medium',
          display:'block'
        }}>
          {refundAggregate.totalCount}
        </span>
        <span style={{
          fontSize:'14px',
          fontWeight:'500',
          fontFamily:'Inter-Medium',
          color:'#667085'
        }}>
    Refunds Raised
        </span>
      </div>
      <div style={{
        backgroundColor:'#f7bdadff ',
        borderRadius:'50%',
        width:'40px',
        height:'40px',
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
        marginLeft:'20px'
      }}>
        <BarChartIcon sx={{ fontSize: '20px' }} />
      </div>
    </div>


{/* approved-amount */}
<div style={{
      backgroundColor: '#F9FAFB',
      borderRadius:'12px',
      display:'flex',
      alignItems:'center',
      height:'70px',
      minWidth:'220px',
      justifyContent:'space-between',
      padding:'16px 20px',
      border:'1px solid #E4E7EC',
      cursor:'pointer'
    }}>
      <div style={{lineHeight:'1.4'}}>
        <span style={{
          color:'#D32028',
          fontSize:'24px',
          fontWeight:'600',
          fontFamily:'Inter-Medium',
          display:'block'
        }}>
           ₹{formatAmount(Math.floor(refundAggregate.approvedAmount))}
          </span>
        <span style={{
          fontSize:'14px',
          fontWeight:'500',
          fontFamily:'Inter-Medium',
          color:'#667085'
        }}>
    Approved Amount
        </span>
      </div>
      <div style={{
        backgroundColor:'#d4f5d7ff',
        borderRadius:'50%',
        width:'40px',
        height:'40px',
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
        marginLeft:'20px'
      }}>
        <CheckBoxOutLinedIcon sx={{ fontSize: '20px' }} />
      </div>
    </div>


  {/* approved-refunds*/}
    {/* <div style={{
      backgroundColor: '#F9FAFB',
      borderRadius:'12px',
      display:'flex',
      alignItems:'center',
      height:'70px',
      minWidth:'220px',
      justifyContent:'space-between',
      padding:'16px 20px',
      border:'1px solid #E4E7EC',
      cursor:'pointer'
    }}>
      <div style={{lineHeight:'1.4'}}>
        <span style={{
          color:'#D32028',
          fontSize:'24px',
          fontWeight:'600',
          fontFamily:'Inter-Medium',
          display:'block'
        }}>
        {refundSummary.approvedRefundCount}
        </span>
        <span style={{
          fontSize:'14px',
          fontWeight:'500',
          fontFamily:'Inter-Medium',
          color:'#667085'
        }}>
    Refunds Approved
        </span>
      </div>
      <div style={{
        backgroundColor:'#DBEAFE',
        borderRadius:'50%',
        width:'40px',
        height:'40px',
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
        marginLeft:'20px'
      }}>
        <VerifiedIcon sx={{ fontSize: '50px' }} />
      </div>
    </div> */}
  </div>
</div>
                
  
 
</div>
<div >
             
<div style={{display:'flex', alignItems:'center', flexWrap:'wrap', gap:'4px',}}>
  
  {/* institute / merchant Search */}
   <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flexWrap: 'nowrap' 
      }}
    >
  <InstituteAutocomplete
    key={instituteResetKey} 
    onInstituteSelect={(id,name) => {
       setId(id);
      setInstituteName(name || '');
      }}
      defaultValue={instituteName}
    searchIcon={search}
    placeholder={
      decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361'
        ? 'Product Type'
        : 'Merchant Name'
    }
    height={'36px'}
    borderColor={'#CACCCE'}
  />
{/* created date range */}
<div style={{display:'flex', alignItems:'center', gap: '4px',marginTop:'5px'}}>
  
    <Datetime
    key={`createdFrom-${createdFromDate}`}
      closeOnSelect={true}
      id="createdFromDate"
      dateFormat="DD MMM YYYY"
      timeFormat={false}
    value={createdFromDate ? new Date(createdFromDate) : null}  
      onChange={(event) => {
        if (event && event.format) {
          setCreatedFromDate(event.startOf('day').format('YYYY-MM-DD'));
        } else {
          setCreatedFromDate(null);  
        }
      }}
      locale="en-gb"
      inputProps={{ 
        placeholder: 'Created From', 
        style: {
          fontFamily: 'Inter-Medium', 
          backgroundImage: `url(${calender})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '8px center',
          backgroundSize: '16px 16px', 
          paddingLeft: '35px',
          fontSize: "14px",
          height: '36px',
          width: '140px',
          border: '1px solid #D0D5DD',
          borderRadius: '8px',
          marginTop:'7px'
        } 
      }}
    />
  <Datetime
      key={createdFromDate}  
      closeOnSelect={true}
      id="createdToDate"
      dateFormat="DD MMM YYYY"
      timeFormat={false}
      value={createdToDate}
      locale="en-gb"
       initialViewDate={
        createdFromDate
        ? moment(createdFromDate, 'YYYY-MM-DD')
        : moment()
        }
      onChange={(event) => {
        if (event && event.format) {
          const endOfDay = event.hour(23).minute(59).second(59).millisecond(999);
          setCreatedToDate(endOfDay.format('YYYY-MM-DD'));
        } else {
          setCreatedToDate(null);
        }
      }}       
      inputProps={{ 
        placeholder: 'Created To', 
        style: {
          fontFamily: 'Inter-Medium', 
          backgroundImage: `url(${calender})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '8px center',
          backgroundSize: '16px 16px', 
          paddingLeft: '35px',
          fontSize: "14px",
          height: '36px',
          width: '140px',
          border: '1px solid #D0D5DD',
          borderRadius: '8px',
          marginTop:'7px'
        } 
      }}
    />
  
</div>
{/* refund processing date */}
<div style={{display:'flex', alignItems:'center', gap: '6px'}}>
<Datetime
    key={`refundFrom-${refundFromDate}`}
      closeOnSelect={true}
      id="refundFromDate"
      dateFormat="DD MMM YYYY"
      timeFormat={false}
     value={refundFromDate ? new Date(refundFromDate) : null}
      onChange={(event) => { 
        if (event && event.format) {
          setRefundFromDate(event.format('YYYY-MM-DD'));
        } else {
setRefundFromDate(null);
        }
      }}
      locale="en-gb"
      inputProps={{ 
        placeholder: 'Refund From', 
        style: {
          fontFamily: 'Inter-Medium', 
          backgroundImage: `url(${calender})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '8px center',
          backgroundSize: '16px 16px', 
          paddingLeft: '35px',
          fontSize: "14px",
          height: '36px',
          width: '140px',
          border: '1px solid #D0D5DD',
          borderRadius: '8px',
          marginTop:'12px'
        } 
      }}
    />
  
 <Datetime
    key={`refundTo-${refundFromDate}`}
      closeOnSelect={true}
      id="refundToDate"
      initialViewDate={
        refundFromDate
       ? moment(refundFromDate, 'YYYY-MM-DD')
      : moment()
          }
      dateFormat="DD MMM YYYY"
      timeFormat={false}
     value={refundToDate ? new Date(refundToDate) : null}
      locale="en-gb"
      onChange={(event) => {
        if (event && event.format) {
          setRefundToDate(event.format('YYYY-MM-DD'));
        } else {
          setRefundToDate(null);
        }
      }}
      inputProps={{ 
        placeholder: 'Refund To', 
        style: {
          fontFamily: 'Inter-Medium', 
          backgroundImage: `url(${calender})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '8px center',
          backgroundSize: '16px 16px', 
          paddingLeft: '35px',
          fontSize: "14px",
          height: '36px',
          width: '140px',
          border: '1px solid #D0D5DD',
          borderRadius: '8px',
          marginTop:'12px'
        } 
      }}
    />
  
 
</div>
</div>
<div style={{ 
  display: 'flex', 
  alignItems: 'flex-end', 
  gap: '6px', 
  flexWrap: 'wrap',

}}>

<div style={{ minWidth: '160px' }}>
  <Input
    type="select"
    value={statusFilter || ''}         
    onChange={(e) => {
      const selectedValue = e.target.value;
      setStatusFilter(selectedValue === '' ? '' : Number(selectedValue));
      setcurrentPage(1);
    }}
    style={{
      color: statusFilter ? '#101828' : '#667085', 
      fontSize: '14px',
      fontFamily: 'Inter-Medium',
      height: '36px',
      width: '100%',
      border: '1px solid #D0D5DD',
      borderRadius: '8px',
      padding: '0 12px',
      backgroundColor: 'white',
      marginTop:'12px'
    }}
  >
    <option value="" disabled>Status</option>
    <option value="">All</option>
    <option value="1">Requested</option>
    <option value="4">Approved</option>
    <option value="5">Refund Received</option>
  </Input>
</div>
 <button
    onClick={() => {
      setcurrentPage(1);
      setTriggerDateSearch(prev => !prev);
    }}
    style={{
      height: '36px',
      padding: '0 12px',
      backgroundColor: '#D22129',
      border: 'none',
      borderRadius: '8px',
      color: 'white',
      fontFamily: 'Inter-Medium',
      fontSize: '16px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      whiteSpace: 'nowrap',
      marginTop: '7px',
      marginLeft:'10px'
    }}
  >Search
  </button>

    <button
  onClick={() => {
    sessionStorage.removeItem(FILTER_KEY);
    setId('');
    setInstituteName('');
    setInstituteResetKey(prev => prev + 1);
    setStatusFilter('');
    setCreatedFromDate(null);
    setCreatedToDate(null);
    setRefundFromDate(null);
    setRefundToDate(null);
    setcurrentPage(1);
     setrowsPerPage(15);
    setTriggerDateSearch(prev => !prev);
  }}
  style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    height: '35px',
    padding: '0 16px',
    backgroundColor: '#D22129',
    border: 'none',
    borderRadius: '8px',
    color: 'white',
    fontFamily: 'Inter-Medium',
    fontSize: '14px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    marginTop:'10px'
  }}
>

  <RefreshIcon/>

</button>
</div>
</div>
 {isLoading ? (
              <Box style={{ display: 'flex',alignItems:'center',justifyContent:'center',padding:'15%'}}>
              <CircularProgress />
            </Box>
            ):(
              <>
               {Array.isArray(tableData)?(
              <div className='tables' >
                
                  <table hover  style={{width:'100%',tableLayout: 'fixed'}}>
                  <thead className='table-heading'>
                      <tr>
                      <th style={{width: '20%',textAlign:'left',paddingLeft:'20px',borderTopLeftRadius:'8px'}}><span style={{color:'#667085',fontFamily:'Inter',fontSize:'0.9vw'}}>Instititue Name</span></th>
                      <th style={{ width: '20%',textAlign:'left',paddingLeft: '20px' }}><span style={{color:'#667085',fontFamily:'Inter',fontSize:'0.9vw',marginLeft:'5px'}}>Student Name</span></th>
                    <th style={{width: '20%', textAlign:'left' ,paddingLeft: '20px',fontFamily:'Inter',fontSize:'0.9vw' ,color:'#667085'}}><span style={{color:'#667085',fontFamily:'Inter',fontSize:'0.9vw',marginLeft:'10px'}}>Amount</span></th>
                     <th style={{ width: '20%', textAlign:'left' ,paddingLeft: '20px',fontFamily:'Inter',fontSize:'0.9vw' ,color:'#667085'}}><span style={{color:'#667085',fontFamily:'Inter',fontSize:'0.9vw',marginRight:'20px'}}>Date Raised</span></th>
                                          <th style={{ width: '20%', textAlign:'left' ,paddingLeft: '20px',fontFamily:'Inter',fontSize:'0.9vw' ,color:'#667085'}}><span style={{color:'#667085',fontFamily:'Inter',fontSize:'0.9vw',marginRight:'20px'}}>Processed Date</span></th>
                    <th style={{ width: '20%',textAlign:'left' ,paddingLeft: '20px',fontFamily:'Inter',fontSize:'0.9vw' ,color:'#667085',width:'10em',borderTopRightRadius:'8px'}}><span style={{color:'#667085',fontFamily:'Inter',fontSize:'0.9vw',marginLeft:'20px'}}>Status</span></th>
                      <th style={{ width: '10%', textAlign:'center', paddingLeft: '20px', borderTopRightRadius:'8px'}}>
  <span style={{color:'#667085',fontFamily:'Inter',fontSize:'14px'}}>Actions</span>
</th>
                </tr>
                  </thead>   
{tableData?.map((item, index) => {
 const dateRaised = item.requestedDate
  ? new Date(item.requestedDate.split('-').reverse().join('-')).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    })
  : '-';

   const refunddateRaised = item.processedDate
  ? new Date(item.processedDate.split('-').reverse().join('-')).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    })
  : '-';

  const isExpanded = expandedRow === index;
  return (
    <tbody className='table-body' key={index}>
      <tr className='table-row' style={{ lineHeight: '14px' }}>
        <td
        style={{cursor:'pointer', maxWidth:'12em',color:'#667085',fontFamily:'Inter',fontSize:'0.9vw',paddingLeft:'20px' }}
        title={item.instituteName || '-'}
        >
          <span style={{
            width: '100%',                    
    fontFamily: 'Inter',
    fontWeight: '400',
      color:'#667085',
    lineHeight:'1.4em',
    fontSize: '14px',
    lineHeight: '1.5em',
    display: 'block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
            }}>
            {item.instituteName || '-'}
          </span>
        </td>

        <td 
        onClick={()=>{
      handleLoanProfile(item.loanId,item.legacyLoanId)
        }}
        style={{
           cursor: 'pointer', 
    maxWidth: '12em', 
    color: '#667085', 
    fontFamily: 'Inter', 
    fontSize: '14px', 
    paddingLeft: '20px'}}
        title={item.userName || '---'}
        >
          <span style=
          {{
           width: '100%',
    fontFamily: 'Inter',
    fontWeight: '500',
    color: '#667085',
    lineHeight: '1.5em',
    fontSize: '14px',
    display: 'block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
             }}>
            {item.userName || '---'}
          </span>
        </td>

        <td>
          <span style={{fontFamily:'Inter',fontSize:'14px',color:'#667085',fontWeight:'500',paddingLeft: '20px'}}>
            ₹{formatNumberWithCommas(item.amount)}
          </span>
        </td>

        <td>
          <span style={{fontFamily:'Inter',fontSize:'14px',color:'#667085',fontWeight:'500',marginLeft:'10px'}}>
            {dateRaised}
          </span>
        </td>

          <td>
          <span style={{fontFamily:'Inter',fontSize:'0.9vw',color:'#667085',fontWeight:'500',marginLeft:'10px'}}>
          {refunddateRaised === 'Invalid Date' ? '-' : refunddateRaised}

          </span>
        </td>

<td style={{ maxWidth: '12em', color: '#667085' }}>
  <span>
    {(() => {
      const statusStr = typeof item.status === 'number'
        ? getRefundStatusLabel(item.status)
        : (item.status || 'Requested');

      switch (statusStr) {
        case 'Requested':
          return (
            <span style={{ padding: '6px 12px', backgroundColor: '#f5d9acff', color: '#F8A31F', borderRadius: '16px', fontWeight: '600', display: 'inline-flex', alignItems: 'center', height: '30px', fontSize: '13px' }}>
              <img src={pendingdot} style={{ width: '8px', height: '8px', marginRight: '8px' }} alt="" />
              Requested
            </span>
          );
        case 'In Review':
          return (
            <span style={{ padding: '6px 12px', backgroundColor: '#97d4fdff', color: '#026AA7', borderRadius: '16px', fontWeight: '600', display: 'inline-flex', alignItems: 'center', height: '30px', fontSize: '13px' }}>
              <img src={tododot} style={{ width: '8px', height: '8px', marginRight: '8px' }} alt="" />
              In Review
            </span>
          );
        case 'Approved':
          return (
            <span style={{ padding: '6px 12px', backgroundColor: '#c9ffdfff', color: '#027A48', borderRadius: '16px', fontWeight: '600', display: 'inline-flex', alignItems: 'center', height: '30px', fontSize: '13px' }}>
              <img src={activedot} style={{ width: '8px', height: '8px', marginRight: '8px' }} alt="" />
              Approved
            </span>
          );
        case 'Rejected':
          return (
            <span style={{ padding: '6px 12px', backgroundColor: '#FFE8E8', color: '#F81F1F', borderRadius: '16px', fontWeight: '600', display: 'inline-flex', alignItems: 'center', height: '30px', fontSize: '13px' }}>
              <img src={closeddot} style={{ width: '8px', height: '8px', marginRight: '8px' }} alt="" />
              Rejected
            </span>
          );
       case 'Refund Received':
  return (
    <span style={{ 
      padding: '6px 12px', 
      backgroundColor: '#ECFDF5', 
      color: '#065F46',             
      borderRadius: '16px', 
      fontWeight: '600', 
      display: 'inline-flex', 
      alignItems: 'center', 
      height: '30px', 
      fontSize: '13px' 
    }}>
      <img src={activedot} style={{ width: '8px', height: '8px', marginRight: '8px' }} alt="" />
      Refund Received
    </span>
  );
       
        default:
          return (
            <span style={{ padding: '6px 12px', backgroundColor: '#FFF6E8', color: '#F8A31F', borderRadius: '16px', fontWeight: '600', display: 'inline-flex', alignItems: 'center', height: '30px', fontSize: '14px' }}>
              <img src={pendingdot} style={{ width: '8px', height: '8px', marginRight: '8px' }} alt="" />
              Requested
            </span>
          );
      }
    })()}
  </span>
</td>

 <td style={{ textAlign: 'center',cursor:'pointer' }}>
   <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
         <span 
onClick={async () => {
  if (isExpanded) {
    setExpandedRow(null);
    setEditData({});
      setPenaltyChecked(false);
  } else {
    setExpandedRow(index);
    // setIsEditLoading(true);

    try {
      
      let statusValue = 1;  
      let statusLabel = 'Requested';

      if (typeof item.status === 'number') {
      
        statusValue = item.status;
        statusLabel = getRefundStatusLabel(item.status);
      } else if (typeof item.status === 'string' && item.status.trim() !== '') {
  statusLabel = item.status;
        statusValue = getRefundStatusValue(item.status);
      }

     setEditData({
  amountReceived: item.amount || '',                   
  prorataInterest:  item.prorateInterestPerAnnum || '',          
  interestStartDate: formatDateForInput(item.interestStartDate),
  statusValue: item.status === 4 ? 4 : 3,              
  statusLabel: item.status === 4 ? 'Approved' : 'Rejected',
  processedDate: formatDateForInput(item.processedDate)
});
setPenaltyChecked(item.prorataInterest && item.interestStartDate ? true : false);

    } catch (err) {
      console.error("Failed to load refund details", err);
      setEditData({
        amountReceived: item.amountReceived || '',
        amountAdjusted: item.amountAdjusted || '',
        statusValue: 1,
        statusLabel: 'Requested',
        processedDate: formatDateForInput(item.processedDate),
      });
      setPenaltyChecked(!!(item.prorateInterestPerAnnum && item.interestStartDate));
    } 
  }
}}
>
  <span title='Edit Refund Details'>
  {isExpanded ? '−' : <img src={edit} alt='edit'  style={{ width: '12px', height: '12px'}} /> }
  </span>
</span>

 {/* aactivity-button */}
    <span
      onClick={() => {
                handleOpenDialog(item.loanId, item.legacyLoanId);
      }}
      title='View Activity'
      style={{ cursor: 'pointer' }}
    >
      <DescriptionIcon style={{ width: '16px', height: '16px', color: '#d32028' }} />
    </span>
    </div>
        </td>
      </tr>
{/* modalfor editoption */}
<Modal
  open={expandedRow === index}
  onClose={() => {
    setExpandedRow(null);
    setEditData({});
  }}
  aria-labelledby="refund-edit-modal"
>
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: { xs: '90%', sm: 600 },
      bgcolor: 'background.paper',
      borderRadius: '8px',
      boxShadow: 24,
      p: 4,
      maxHeight: '90vh',
      overflowY: 'auto',
    }}
  >
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
      <h3 style={{ margin: 0, fontFamily: 'Inter-Medium', color: '#101828', fontSize: '20px' }}>
        Edit Refund Details
      </h3>
      <IconButton
        aria-label="close"
        onClick={() => {
          setExpandedRow(null);
          setEditData({});
        }}
        sx={{
          color: '#667085',
          '&:hover': {
            backgroundColor: '#f5f5f5',
          },
        }}
      >
        <CloseIcon />
      </IconButton>
    </Box>

    <hr style={{ border: '1px solid #E4E7EC', margin: '12px 0' }} />

    {isEditLoading ? (
      <Box display="flex" justifyContent="center" my={4}>
        <CircularProgress />
      </Box>
    ) : (
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px', marginTop: '16px' }}>
        <div>
          <label style={{ fontSize: '14px', color: '#344054', fontFamily: 'Inter-Medium' }}>Loan ID</label>
          <Input
            type="text"
            value={item.legacyLoanId || '-'}
            disabled
            style={{ height: '40px', fontSize: '14px', backgroundColor: '#f5f5f5', marginTop: '6px', width: '100%' }}
          />
        </div>

        <div>
          <label style={{ fontSize: '14px', color: '#344054', fontFamily: 'Inter-Medium' }}>Refund Amount</label>
          <Input
            type="number"
            value={editData.amountReceived || ''}
            onChange={(e) => setEditData(prev => ({ ...prev, amountReceived: e.target.value }))}
            style={{ height: '40px', fontSize: '14px', marginTop: '6px', width: '100%' }}
          />
        </div>

        

        <div>
  <label style={{ fontSize: '14px', color: '#344054', fontFamily: 'Inter-Medium' }}>
    Status
  </label>
  <Input
    type="select"
    value={editData.statusLabel || 'Requested'}
    onChange={(e) => {
      const label = e.target.value;
      const value = label === 'Approved' ? 4 : 3;
      setEditData(prev => ({
        ...prev,
        statusLabel: label,
        statusValue: value,
      }));
    }}
    style={{ height: '40px', fontSize: '14px', marginTop: '6px', width: '100%' }}
  >
    <option value="Approved">Approved</option>
      <option value="Rejected">Rejected</option>
  </Input>
</div>

    {/* <div>
          <label style={{ fontSize: '14px', color: '#344054', fontFamily: 'Inter-Medium' }}>Processed Date</label>
          <Input
            type="date"
            value={editData.processedDate || ''}
            onChange={(e) => setEditData(prev => ({ ...prev, processedDate: e.target.value }))}
            style={{ height: '40px', fontSize: '14px', marginTop: '6px', width: '100%' }}
          />
        </div> */}
     

{editData.statusLabel === 'Approved' && (
    <div style={{ gridColumn: '1 / -1' }}> {/* full width */}
      <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', color: '#344054', fontFamily: 'Inter-Medium' }}>
        <input
          type="checkbox"
          checked={penaltyChecked}
          onChange={(e) => setPenaltyChecked(e.target.checked)}
        />
        Apply Penalty
      </label>

      {penaltyChecked && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginTop: '12px' }}>
          {/* Percentage (pa) */}
          <div>
            <label style={{ fontSize: '14px', color: '#344054', fontFamily: 'Inter-Medium' }}>Percentage (p.a.)</label>
            <Input
              type="number"
              placeholder="e.g. 4"
              value={editData.prorataInterest || ''}
              onChange={(e) => setEditData(prev => ({ ...prev, prorataInterest: e.target.value }))}
              style={{ height: '40px', fontSize: '14px', marginTop: '6px', width: '100%' }}
            />
          </div>

          {/* Interest Start Date */}
          <div>
            <label style={{ fontSize: '14px', color: '#344054', fontFamily: 'Inter-Medium' }}>Interest Start Date</label>
            <Input
              type="date"
              value={editData.interestStartDate || ''}
              onChange={(e) => setEditData(prev => ({ ...prev, interestStartDate: e.target.value }))}
              style={{ height: '40px', fontSize: '14px', marginTop: '6px', width: '100%' }}
            />
          </div>
        </div>
      )}
    </div>
  )}

        <div style={{ display: 'flex', alignItems: 'end' }}>
          <button
            onClick={() => handleUpdateRefund(item.legacyLoanId)}
            style={{
              backgroundColor: '#D22129',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px',
              fontFamily: 'Inter-Medium',
              height: '40px',
               display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
            }}
          >
            Submit
          </button>
        </div>
      </div>
    )}
  </Box>
</Modal>
    </tbody>
  );
})}
</table>

<Dialog
  fullScreen
  open={isDialogOpen}
  onClose={handleCloseDialog}
  TransitionComponent={Transition}
  PaperProps={{
    sx: {
      width: "50%",
      maxWidth: "80vw",
      height: "100vh",
      ml: "auto",
      borderTopLeftRadius: "15px",
      borderBottomLeftRadius: "15px",
    },
  }}
>
  <DialogContent>
    <LoanActivity />
  </DialogContent>
</Dialog>

    </div>
            ):''}
<div style={{ 
  display: "flex", 
  justifyContent: "center", 
  alignItems: "center", 
  marginTop: "20px", 
  flexWrap: "wrap", 
  gap: "10px",
  fontFamily: "Inter"
}}>

  <div style={{ 
    fontWeight: "bold", 
    fontSize: "14px", 
    whiteSpace: "nowrap",
    color: "#344054"
  }}>
    {totalFetchRows > 0 ? (
      <>
        Showing {(currentPage - 1) * rowsPerPage + 1}-
        {Math.min(currentPage * rowsPerPage, totalFetchRows)} records of {totalFetchRows} |
      </>
    ) : (
      "No Records"
    )}
  </div>


  <div style={{ 
    display: "flex", 
    alignItems: "center", 
    gap: "5px",
    whiteSpace: "nowrap"
  }}>
    <span style={{ fontWeight: "600", color: "#344054" }}>
      Rows Per Pages :
    </span>
    <div style={{ display: "flex", gap: "4px" }}>
      {[15, 50, 100, 500].map((size) => (
        <span
          key={size}
          onClick={() => {
            setrowsPerPage(size);
            setcurrentPage(1);
          }}
          style={{
            cursor: "pointer",
            padding: "4px 8px",
            fontSize: "14px",
            fontWeight: rowsPerPage === size ? "600" : "500",
            color: rowsPerPage === size ? "#D22129" : "#344054",
            backgroundColor: rowsPerPage === size ? "#FFF2F3" : "transparent",
            borderRadius: "8px",
            transition: "all 0.2s"
          }}
        >
          {size}
        </span>
      ))}
    </div>
  </div>
</div>


<PaginationTable
  startPage={currentPage} 
  rowsPerPage={rowsPerPage}
  totalRows={totalFetchRows}
  paginate={paginate}
  searchText={searchText}
/>
 </>
            )}
              </div>
        </div>
    )
}
export default RefundsTracker;

 